
import React, { useState } from 'react';
import { Switch, Route } from 'react-router-dom';


import Dashboard from './pages/Dashboard/Dahboard';
import Admin from './pages/Admin/Admin';
import Agency from './pages/Agency/Agency';
import Showroom from './pages/Showroom/Showroom';
import ShowroomOperator from './pages/ShowroomOperator/ShowroomOperator';
import CreateAdmin from './pages/CreateAdmin/CreateAdmin';
// import DetailAdmin from './pages/DetailAdmin/DetailAdmin';
import DetailAdminLayout from './pages/DetailAdmin/layout';
import CreateAgency from './pages/CreateAgency/CreateAgency';
import DetailAgency from './pages/DetailAgency/DetailAgency';
import DetailAgencyLayout from './pages/DetailAgency/layout';
import CreateShowroom from './pages/CreateShowroom/CreateShowroom';
import CreateShowroomOperator from './pages/CreateShowroomOperator/CreateShowroomOperator';
import DetailShowroom from './pages/DetailShowroom/DetailShowroom';
import DetailShowroomLayout from './pages/DetailShowroom/layout';
import DetailAgentLayout from './pages/DetailAgent/layout';
import DetailShowroomOperatorLayout from './pages/DetailShowroomOperator/layout';
import DetailAppointmentLayout from './pages/DetailAppointment/layout';
import AppointmentDemo from './pages/AppointmentDemo/AppointmentDemo';
import Dashboard_agency from './pages/Dashboard_agency/Dashboard_agency';
import Dashboard_showroom from './pages/Dashboard_showroom/Dashboard_showroom';
import BarChartAgency from './pages/BarChartAgency/BarChartAgency';

import Login from './pages/Login/Login';

import { CssBaseline, useMediaQuery } from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';

import Header from '../src/components/Header/Header';
import Sidebar from '../src/components/Sidebar/Sidebar';
import CreateTimetable from './pages/CreateTimetable/CreateTimetable';
import CreateSpecialTimetable from './pages/CreateSpecialTimetable/CreateSpecialTimetable';
import CreateTimetableDemo from './pages/CreateTimetableDemo/CreateTimetableDemo';
import EditTimetable from './pages/EditTimetable/EditTimetable';
import DetailTimetable from './pages/DetailTimetable/DetailTimetable';

import Agent from './pages/Agent/Agent';
import CreateAgent from './pages/CreateAgent/CreateAgent';
import DetailAgent from './pages/DetailAgent/DetailAgent';

import Appointment from './pages/Appointment/Appointment';
import CreateAppointment from './pages/CreateAppointment/CreateAppointment';
import DetailAppointment from './pages/DetailAppointment/DetailAppointment'; 

import backgroundIMG from '../src/assets/ihr.jpg';
import EditShowroom from './pages/EditShowroom/EditShowroom';

import BarChart from './pages/BarChart/BarChart';
import ReportAgency from './pages/ReportAgency/ReportAgency';
import ReportAgencyOverview from './pages/ReportAgencyOverview/ReportAgencyOverview';
import ReportProperty from './pages/ReportProperty/ReportProperty';
import ReportPropertyDemo from './pages/ReportProperty/ReportPropertyDemo';
import ReportPropertyOverview from './pages/ReportPropertyOverview/ReportPropertyOverview';
import ReportTimeAgency from './pages/ReportTimeAgency/ReportTimeAgency';
import ReportTimeProperty from './pages/ReportTimeProperty/ReportTimeProperty';
 
import ResetPassword from './pages/ResetPassword/ResetPassword';
import ForgotPassword from './pages/ForgotPassword/ForgotPassword';
import ReportAgencyGuest from './pages/ReportAgencyGuest/ReportAgencyGuest';
import ReportPropertyGuest from './pages/ReportPropertyGuest/ReportPropertyGuest';


const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
    root: {
        // backgroundColor: theme.palette.white,
        display: 'flex',
        flexDirection: 'column',
        height: '100vh',
        padding: theme.spacing(2)
    },

    shiftContent: {
        paddingLeft: 0
    },

    appBar: {
        [theme.breakpoints.up('md')]: {
            width: `calc(100% - ${drawerWidth}px)`,
            marginLeft: drawerWidth,
        },
        zIndex: theme.zIndex.drawer + 1,
    },
    menuButton: {
        marginRight: theme.spacing(2),
        [theme.breakpoints.up('md')]: {
            display: 'none',
        },
    },

    // necessary for content to be below app bar
    toolbar: theme.mixins.toolbar,

    drawerPaper: {
        width: drawerWidth,
        flexShrink: 0,

    },
    content: {
        // flexGrow: 1,
        height: '100%',
        // padding: theme.spacing(3),
        [theme.breakpoints.up('md')]: {
            paddingLeft: '240px',
        },
    },

    logincontent: {
        // flexGrow: 1,
        height: '100vh',
        backgroundImage: `url(${backgroundIMG})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',

    },

    divider: {
        margin: theme.spacing(2, 0)
    },

    nav: {
        marginBottom: theme.spacing(2)
    },

    title: {
        flexGrow: 1
    },

    link: {
        textDecoration: 'none',
        color: theme.palette.text.primary,

    }

}));


export default function Routes(agency) {

    const classes = useStyles();
    const theme = useTheme();
    // const [mobileOpen, setMobileOpen] = React.useState(false);

    // const handleDrawerToggle = () => {
    //         setMobileOpen(!mobileOpen);
    // };

    const isDesktop = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true
    });

    const [openSidebar, setOpenSidebar] = useState(false);

    const handleSidebarOpen = () => {
        setOpenSidebar(true);
    };

    const handleSidebarClose = () => {
        setOpenSidebar(false);
    };

    // const shouldOpenSidebar = isDesktop ? true : openSidebar;
    const shouldOpenSidebar = isDesktop ? true : openSidebar;
    return (

        <Switch>

            <Route exact path="/">
                <main className={classes.logincontent}>
                    <div className={classes.toolbar} />
                    <Login />

                </main>
            </Route>

            <Route exact path="/dashboard" >
                <Header
                    classes={classes}
                    onSidebarOpen={handleSidebarOpen}
                />
                <Sidebar
                    classes={classes}
                    onClose={handleSidebarClose}
                    open={shouldOpenSidebar}
                    variant={isDesktop ? 'persistent' : 'temporary'}
                />
                <main className={classes.content}>
                    <div className={classes.toolbar} />
                    <Dashboard />

                </main>
            </Route>

            <Route exact path="/admin">
                <Header
                    classes={classes}
                    onSidebarOpen={handleSidebarOpen}
                />
                <Sidebar
                    classes={classes}
                    onClose={handleSidebarClose}
                    open={shouldOpenSidebar}
                    variant={isDesktop ? 'persistent' : 'temporary'}
                />
                <main className={classes.content}>
                    <div className={classes.toolbar} />
                    <Admin />

                </main>
            </Route>

            <Route exact path="/agency_admins/:id" render={(props) => (
                <>
                    <Header
                        classes={classes}
                        onSidebarOpen={handleSidebarOpen}
                    />
                    <Sidebar
                        classes={classes}
                        onClose={handleSidebarClose}
                        open={shouldOpenSidebar}
                        variant={isDesktop ? 'persistent' : 'temporary'}
                    />
                    <main className={classes.content} {...props}>
                        <div className={classes.toolbar} />
                        <Agent {...props} />

                    </main>
                </>
            )}>

            </Route>

            <Route exact path="/agency">
                <Header
                    classes={classes}
                    onSidebarOpen={handleSidebarOpen}
                />
                <Sidebar
                    classes={classes}
                    onClose={handleSidebarClose}
                    open={shouldOpenSidebar}
                    variant={isDesktop ? 'persistent' : 'temporary'}
                />
                <main className={classes.content}>
                    <div className={classes.toolbar} />
                    <Agency />

                </main>
            </Route>


            <Route exact path="/operator">
                <Header
                    classes={classes}
                    onSidebarOpen={handleSidebarOpen}
                />
                <Sidebar
                    classes={classes}
                    onClose={handleSidebarClose}
                    open={shouldOpenSidebar}
                    variant={isDesktop ? 'persistent' : 'temporary'}
                />
                <main className={classes.content}>
                    <div className={classes.toolbar} />
                    <ShowroomOperator />

                </main>
            </Route>

            <Route exact path="/showroom">
                <Header
                    classes={classes}
                    onSidebarOpen={handleSidebarOpen}
                />
                <Sidebar
                    classes={classes}
                    onClose={handleSidebarClose}
                    open={shouldOpenSidebar}
                    variant={isDesktop ? 'persistent' : 'temporary'}
                />
                <main className={classes.content}>
                    <div className={classes.toolbar} />
                    <Showroom />

                </main>
            </Route>

            <Route exact path="/admin/createadmin">
                <Header
                    classes={classes}
                    onSidebarOpen={handleSidebarOpen}
                />
                <Sidebar
                    classes={classes}
                    onClose={handleSidebarClose}
                    open={shouldOpenSidebar}
                    variant={isDesktop ? 'persistent' : 'temporary'}
                />
                <main className={classes.content}>
                    <div className={classes.toolbar} />
                    <CreateAdmin />
                </main>
            </Route>
            <Route exact path="/agency_overview" render={(props) => (
                <React.Fragment>

                    <BarChartAgency
                        {...props}
                        classes={classes}
                        handleSidebarOpen={handleSidebarOpen}
                        handleSidebarClose={handleSidebarClose}
                        isDesktop={isDesktop}
                        shouldOpenSidebar={shouldOpenSidebar}
                    />
                </React.Fragment>
            )}>
            </Route>
            <Route exact path="/property_overview" render={(props) => (
                <React.Fragment>

                    <BarChart
                        {...props}
                        classes={classes}
                        handleSidebarOpen={handleSidebarOpen}
                        handleSidebarClose={handleSidebarClose}
                        isDesktop={isDesktop}
                        shouldOpenSidebar={shouldOpenSidebar}
                    />
                </React.Fragment>
            )}>
            </Route>
            <Route exact path="/report_property" render={(props) => (
                <React.Fragment>

                    <ReportProperty
                        {...props}
                        classes={classes}
                        handleSidebarOpen={handleSidebarOpen}
                        handleSidebarClose={handleSidebarClose}
                        isDesktop={isDesktop}
                        shouldOpenSidebar={shouldOpenSidebar}
                    />
                </React.Fragment>
            )}>
            </Route>
            <Route exact path="/report_time_agency" render={(props) => (
                <React.Fragment>

                    <ReportTimeAgency
                        {...props}
                        classes={classes}
                        handleSidebarOpen={handleSidebarOpen}
                        handleSidebarClose={handleSidebarClose}
                        isDesktop={isDesktop}
                        shouldOpenSidebar={shouldOpenSidebar}
                    />
                </React.Fragment>
            )}>
            </Route>
            <Route exact path="/report_time_property" render={(props) => (
                <React.Fragment>

                    <ReportTimeProperty
                        {...props}
                        classes={classes}
                        handleSidebarOpen={handleSidebarOpen}
                        handleSidebarClose={handleSidebarClose}
                        isDesktop={isDesktop}
                        shouldOpenSidebar={shouldOpenSidebar}
                    />
                </React.Fragment>
            )}>
            </Route>
            <Route exact path="/property_by_agency" render={(props) => (
                <React.Fragment>

                    <ReportPropertyOverview
                        {...props}
                        classes={classes}
                        handleSidebarOpen={handleSidebarOpen}
                        handleSidebarClose={handleSidebarClose}
                        isDesktop={isDesktop}
                        shouldOpenSidebar={shouldOpenSidebar}
                    />
                </React.Fragment>
            )}>
            </Route>

            <Route exact path="/agency_by_property" render={(props) => (
                <React.Fragment>

                    <ReportAgencyOverview
                        {...props}
                        classes={classes}
                        handleSidebarOpen={handleSidebarOpen}
                        handleSidebarClose={handleSidebarClose}
                        isDesktop={isDesktop}
                        shouldOpenSidebar={shouldOpenSidebar}
                    />
                </React.Fragment>
            )}>
            </Route>
            <Route exact path="/agency_guest" render={(props) => (
                <React.Fragment>
                    <ReportAgencyGuest
                        {...props}
                        classes={classes}
                        handleSidebarOpen={handleSidebarOpen}
                        handleSidebarClose={handleSidebarClose}
                        isDesktop={isDesktop}
                        shouldOpenSidebar={shouldOpenSidebar}
                    ></ReportAgencyGuest>
                  
                </React.Fragment>
            )}>
            </Route>
            <Route exact path="/property_guest" render={(props) => (
                <React.Fragment>

                    <ReportPropertyGuest
                        {...props}
                        classes={classes}
                        handleSidebarOpen={handleSidebarOpen}
                        handleSidebarClose={handleSidebarClose}
                        isDesktop={isDesktop}
                        shouldOpenSidebar={shouldOpenSidebar}
                    />
                </React.Fragment>
            )}>
            </Route>
            <Route exact path="/overview" render={(props) => (
                <React.Fragment>

                    <BarChart
                        {...props}
                        classes={classes}
                        handleSidebarOpen={handleSidebarOpen}
                        handleSidebarClose={handleSidebarClose}
                        isDesktop={isDesktop}
                        shouldOpenSidebar={shouldOpenSidebar}
                    />
                </React.Fragment>
            )}>
            </Route>
            <Route exact path="/report_agency" render={(props) => (
                <React.Fragment>

                    <ReportAgency
                        {...props}
                        classes={classes}
                        handleSidebarOpen={handleSidebarOpen}
                        handleSidebarClose={handleSidebarClose}
                        isDesktop={isDesktop}
                        shouldOpenSidebar={shouldOpenSidebar}
                    />
                </React.Fragment>
            )}>
            </Route>
            <Route exact path="/admin/detailadmin/:id" render={(props) => (

                <DetailAdminLayout
                    {...props}
                    classes={classes}
                    handleSidebarOpen={handleSidebarOpen}
                    handleSidebarClose={handleSidebarClose}
                    isDesktop={isDesktop}
                    shouldOpenSidebar={shouldOpenSidebar}
                />
            )}>
            </Route>
            <Route exact path="/agency_create_admins/:id" render={(props) => (
                <>
                    <Header
                        classes={classes}
                        onSidebarOpen={handleSidebarOpen}
                    />
                    <Sidebar
                        classes={classes}
                        onClose={handleSidebarClose}
                        open={shouldOpenSidebar}
                        variant={isDesktop ? 'persistent' : 'temporary'}
                    />
                    <main className={classes.content}>
                        <div className={classes.toolbar} />
                        <CreateAgent {...props} key={agency.agency_id} />
                    </main>
                </>
            )}>

            </Route>

            <Route exact path="/operator/createshowroomoperator">
                <Header
                    classes={classes}
                    onSidebarOpen={handleSidebarOpen}
                />
                <Sidebar
                    classes={classes}
                    onClose={handleSidebarClose}
                    open={shouldOpenSidebar}
                    variant={isDesktop ? 'persistent' : 'temporary'}
                />
                <main className={classes.content}>
                    <div className={classes.toolbar} />
                    <CreateShowroomOperator classes={classes} />
                </main>
            </Route>



            {/* <Route exact path="/agent/detailagent/:id">
                <Header 
                    classes={classes}
                    onSidebarOpen={handleSidebarOpen}
                />
                <Sidebar
                    classes={classes}
                    onClose={handleSidebarClose}
                    open={shouldOpenSidebar}
                    variant={isDesktop ? 'persistent' : 'temporary'}
                /> 
                <main className={classes.content}>
                    <div className={classes.toolbar} />
                    <DetailAgent/>
                    
                </main>
            </Route> */}
            <Route exact path="/operator/detailoperator/:id" render={(props) => (

                <DetailShowroomOperatorLayout
                    {...props}
                    classes={classes}
                    handleSidebarOpen={handleSidebarOpen}
                    handleSidebarClose={handleSidebarClose}
                    isDesktop={isDesktop}
                    shouldOpenSidebar={shouldOpenSidebar}
                />
            )}>
            </Route>
            <Route exact path="/agency_admins/detailadmin/:id" render={(props) => (

                <DetailAgentLayout
                    {...props}
                    classes={classes}
                    handleSidebarOpen={handleSidebarOpen}
                    handleSidebarClose={handleSidebarClose}
                    isDesktop={isDesktop}
                    shouldOpenSidebar={shouldOpenSidebar}
                />
            )}>
            </Route>

            <Route exact path="/agency/createagency">
                <Header
                    classes={classes}
                    onSidebarOpen={handleSidebarOpen}
                />
                <Sidebar
                    classes={classes}
                    onClose={handleSidebarClose}
                    open={shouldOpenSidebar}
                    variant={isDesktop ? 'persistent' : 'temporary'}
                />
                <main className={classes.content}>
                    <div className={classes.toolbar} />
                    <CreateAgency />
                </main>
            </Route>

            {/* <Route exact path="/agency/detailagency/:id">
                <Header 
                    classes={classes}
                    onSidebarOpen={handleSidebarOpen}
                />
                <Sidebar
                    classes={classes}
                    onClose={handleSidebarClose}
                    open={shouldOpenSidebar}
                    variant={isDesktop ? 'persistent' : 'temporary'}
                />  
                <main className={classes.content}>
                    <div className={classes.toolbar} />
                    <DetailAgency/>
                </main>
            </Route> */}
            <Route exact path="/agency/detailagency/:id" render={(props) => (

                <DetailAgencyLayout
                    {...props}
                    classes={classes}
                    handleSidebarOpen={handleSidebarOpen}
                    handleSidebarClose={handleSidebarClose}
                    isDesktop={isDesktop}
                    shouldOpenSidebar={shouldOpenSidebar}
                />
            )}>
            </Route>
            <Route exact path="/showroom/detailshowroom/:id" render={(props) => (

                <DetailShowroomLayout
                    {...props}
                    classes={classes}
                    handleSidebarOpen={handleSidebarOpen}
                    handleSidebarClose={handleSidebarClose}
                    isDesktop={isDesktop}
                    shouldOpenSidebar={shouldOpenSidebar}
                />
            )}>
            </Route>

            <Route exact path="/showroom/createshowroom" render={(props) => (
                <React.Fragment>
                    <Header
                        classes={classes}
                        onSidebarOpen={handleSidebarOpen}
                    />
                    <Sidebar
                        classes={classes}
                        onClose={handleSidebarClose}
                        open={shouldOpenSidebar}
                        variant={isDesktop ? 'persistent' : 'temporary'}
                    />
                    <main className={classes.content}>
                        <div className={classes.toolbar} />
                        <CreateShowroom

                            {...props}
                            is_edit={false}
                        />
                    </main>
                </React.Fragment>
            )}>

            </Route>

            <Route exact path="/showroom/editshowroom/:id" render={(props) => (
                <React.Fragment>
                    <Header
                        classes={classes}
                        onSidebarOpen={handleSidebarOpen}
                    />
                    <Sidebar
                        classes={classes}
                        onClose={handleSidebarClose}
                        open={shouldOpenSidebar}
                        variant={isDesktop ? 'persistent' : 'temporary'}
                    />
                    <main className={classes.content}>
                        <div className={classes.toolbar} />
                        <EditShowroom
                            classes={classes}
                            {...props}
                            is_edit={true}
                        />
                    </main>
                </React.Fragment>
            )}>

            </Route>
            {/* <Route exact path="/showroom/detailshowroom/:id">
                <Header 
                    classes={classes}
                    onSidebarOpen={handleSidebarOpen}
                />
                <Sidebar
                    classes={classes}
                    onClose={handleSidebarClose}
                    open={shouldOpenSidebar}
                    variant={isDesktop ? 'persistent' : 'temporary'}
                /> 
                <main className={classes.content}>
                    <div className={classes.toolbar} />

                    <DetailShowroom/>
                </main>
            </Route> */}
            <Route exact path="/showroom/createtimetableDemo/:id" render={(props) => (
                <React.Fragment>
                    <Header
                        classes={classes}
                        onSidebarOpen={handleSidebarOpen}
                    />
                    <Sidebar
                        classes={classes}
                        onClose={handleSidebarClose}
                        open={shouldOpenSidebar}
                        variant={isDesktop ? 'persistent' : 'temporary'}
                    />
                    <main className={classes.content}>
                        <div className={classes.toolbar} />

                        <CreateTimetableDemo
                            classes={classes}
                            {...props}
                        />
                    </main>
                </React.Fragment>
            )}>


            </Route>
            <Route exact path="/createspecialtimetable/:id" render={(props) => (
                <React.Fragment>
                    <Header
                        classes={classes}
                        onSidebarOpen={handleSidebarOpen}
                    />
                    <Sidebar
                        classes={classes}
                        onClose={handleSidebarClose}
                        open={shouldOpenSidebar}
                        variant={isDesktop ? 'persistent' : 'temporary'}
                    />
                    <main className={classes.content}>
                        <div className={classes.toolbar} />

                        <CreateSpecialTimetable
                            is_special={1}
                            classes={classes}
                            {...props}
                        />
                    </main>
                </React.Fragment>
            )}>


            </Route>

            <Route exact path="/showroom/createtimetable/:id" render={(props) => (
                <React.Fragment>
                    <Header
                        classes={classes}
                        onSidebarOpen={handleSidebarOpen}
                    />
                    <Sidebar
                        classes={classes}
                        onClose={handleSidebarClose}
                        open={shouldOpenSidebar}
                        variant={isDesktop ? 'persistent' : 'temporary'}
                    />
                    <main className={classes.content}>
                        <div className={classes.toolbar} />

                        <CreateTimetable
                            classes={classes}
                            {...props}
                        />
                    </main>
                </React.Fragment>
            )}>


            </Route>
            <Route exact path="/editspecialtimetable/:id" render={(props) => (
                <React.Fragment>
                    <Header
                        classes={classes}
                        onSidebarOpen={handleSidebarOpen}
                    />
                    <Sidebar
                        classes={classes}
                        onClose={handleSidebarClose}
                        open={shouldOpenSidebar}
                        variant={isDesktop ? 'persistent' : 'temporary'}
                    />
                    <main className={classes.content}>
                        <div className={classes.toolbar} />

                        <EditTimetable
                            is_special={true}
                            classes={classes}
                            {...props}
                        />
                    </main>
                </React.Fragment>

            )}>

            </Route>
            <Route exact path="/edittimetable/:id" render={(props) => (
                <React.Fragment>
                    <Header
                        classes={classes}
                        onSidebarOpen={handleSidebarOpen}
                    />
                    <Sidebar
                        classes={classes}
                        onClose={handleSidebarClose}
                        open={shouldOpenSidebar}
                        variant={isDesktop ? 'persistent' : 'temporary'}
                    />
                    <main className={classes.content}>
                        <div className={classes.toolbar} />

                        <EditTimetable
                            classes={classes}
                            {...props}
                        />
                    </main>
                </React.Fragment>

            )}>

            </Route>
            {/* <Route exact path="/createspecialtimetable/:id" render={(props) => (
                <React.Fragment>
                    <Header
                        classes={classes}
                        onSidebarOpen={handleSidebarOpen}
                    />
                    <Sidebar
                        classes={classes}
                        onClose={handleSidebarClose}
                        open={shouldOpenSidebar}
                        variant={isDesktop ? 'persistent' : 'temporary'}
                    />
                    <main className={classes.content}>
                        <div className={classes.toolbar} />

                        <CreateTimetable
                            is_special={1}
                            classes={classes}
                            {...props}
                        />
                    </main>
                </React.Fragment>
            )}>

            </Route> */}
            <Route exact path="/booking/detailbooking/:id">
                <Header
                    classes={classes}
                    onSidebarOpen={handleSidebarOpen}
                />
                <Sidebar
                    classes={classes}
                    onClose={handleSidebarClose}
                    open={shouldOpenSidebar}
                    variant={isDesktop ? 'persistent' : 'temporary'}
                />
                <main className={classes.content}>
                    <div className={classes.toolbar} />

                    <DetailTimetable />
                </main>
            </Route>

            <Route exact path="/login">
                <main className={classes.logincontent}>
                    <div className={classes.toolbar} />
                    <Login />

                </main>
            </Route>

            <Route exact path="/resetpassword/:token" render={(props) => (
                <main className={classes.logincontent}>
                    <div className={classes.toolbar} />
                    <ResetPassword {...props} />

                </main>
            )}>

            </Route>

            <Route exact path="/forgotpassword">
                <main className={classes.logincontent}>
                    <div className={classes.toolbar} />
                    <ForgotPassword />

                </main>
            </Route>
            <Route exact path="/appointment">
                <Header
                    classes={classes}
                    onSidebarOpen={handleSidebarOpen}
                />
                <Sidebar
                    classes={classes}
                    onClose={handleSidebarClose}
                    onOpen={handleSidebarOpen}
                    open={shouldOpenSidebar}
                    variant={isDesktop ? 'persistent' : 'temporary'}
                />
                <main className={classes.content}>
                    <div className={classes.toolbar} />
                    <AppointmentDemo />
                </main>
            </Route>

            <Route exact path="/appointmentdemo">
                <Header
                    classes={classes}
                    onSidebarOpen={handleSidebarOpen}
                />
                <Sidebar
                    classes={classes}
                    onClose={handleSidebarClose}
                    onOpen={handleSidebarOpen}
                    open={shouldOpenSidebar}
                    variant={isDesktop ? 'persistent' : 'temporary'}
                />
                <main className={classes.content}>
                    <div className={classes.toolbar} />
                    <AppointmentDemo />
                </main>
            </Route>

            <Route exact path="/dashboard_agency" render={(props) => (
                <Dashboard_agency
                    {...props}
                    classes={classes}
                    handleSidebarOpen={handleSidebarOpen}
                    handleSidebarClose={handleSidebarClose}
                    isDesktop={isDesktop}
                    shouldOpenSidebar={shouldOpenSidebar}
                ></Dashboard_agency>

            )} />

            <Route exact path="/dashboard_showroom" render={(props) => (
                <Dashboard_showroom
                    {...props}
                    classes={classes}
                    handleSidebarOpen={handleSidebarOpen}
                    handleSidebarClose={handleSidebarClose}
                    isDesktop={isDesktop}
                    shouldOpenSidebar={shouldOpenSidebar}
                ></Dashboard_showroom>

            )} />

            <Route exact path="/appointment/createappointment">
                <Header
                    classes={classes}
                    onSidebarOpen={handleSidebarOpen}
                />
                <Sidebar
                    classes={classes}
                    onClose={handleSidebarClose}
                    open={shouldOpenSidebar}
                    variant={isDesktop ? 'persistent' : 'temporary'}
                />
                <main className={classes.content}>
                    <div className={classes.toolbar} />
                    <CreateAppointment />
                </main>
            </Route>


            {/* <Route exact path="/appointment/detailappointment/:id">
                <Header 
                    classes={classes}
                    onSidebarOpen={handleSidebarOpen}
                />
                <Sidebar
                    classes={classes}
                    onClose={handleSidebarClose}
                    open={shouldOpenSidebar}
                    variant={isDesktop ? 'persistent' : 'temporary'}
                /> 
                <main className={classes.content}>
                    <div className={classes.toolbar} />

                    <DetailAppointment/>
                </main>
            </Route> */}
            <Route exact path="/appointment/detailappointment/:id" render={(props) => (

                <DetailAppointmentLayout
                    {...props}
                    classes={classes}
                    handleSidebarOpen={handleSidebarOpen}
                    handleSidebarClose={handleSidebarClose}
                    isDesktop={isDesktop}
                    shouldOpenSidebar={shouldOpenSidebar}
                />
            )}>
            </Route>


        </Switch>

    )

}



// import React, {lazy} from 'react';
// import {Redirect} from 'react-router-dom';
            // import Dashboard from '../src/pages/Dashboard/Dahboard';

            // const routes = [
//     {
//       path: '/',
//       exact: true,
//       component: () => <Redirect to="/dashboard" />
//     },

//     {
//       route: '*',
//       component: Dashboard,
//       routes: [

//         {
//           path: '/dashboard',
//           exact: true,
//           component: Dashboard
//         },

//         {
//           path: '/admin',
//           exact: true,
//           component: lazy(() => import('../src/pages/Admin/Admin'))
//         },
//         {
//             path: '/admin/createadmin',
//             exact: true,
//             component: lazy(() => import('../src/pages/CreateAdmin/CreateAdmin'))
//           },
//         {
//           path: '/admin/detailadmin/:id',
//           exact: true,
//           component: lazy(() => import('../src/pages/DetailAdmin/DetailAdmin'))
//         },

//         {
//           path: '/agency',
//           exact: true,
//           component: lazy(() => import('../src/pages/Agency/Agency'))
//         },
//         {
//           path: '/showroom',
//           exact: true,
//           component: lazy(() => import('../src/pages/Showroom/Showroom'))
//         },


//       ]
//     }
//   ];

//   export default routes;

